import { useLocation } from 'react-router-dom';
import { SettingsLeftNavbarMedicationSubTabs } from '../../components/Navbars/types';
import { MedicationMedCatalogue } from '../../components/Users/MedicationMedCatalogue';
import { MedicationOrderSets } from '../../components/Users/MedicationOrderSets';
import { SystemPermission } from '../../../context';
import { useSelector } from 'react-redux';
import { MedicationMedCatalogueProvider } from '../../components/Users/MedicationMedCatalogue/context/MedicationMedCatalogueProvider';

const titleMap = {
  [SettingsLeftNavbarMedicationSubTabs.MEDICATION_PROFILE_SETTINGS_ORDER]:
    'Order sets',
  [SettingsLeftNavbarMedicationSubTabs.MEDICATION_PROFILE_SETTINGS_MED]:
    'Medicine catalogue',
};

export const MedicationProfileSettings = () => {
  const location = useLocation();
  const { hash } = location;
  const locationKey = hash.replace('#', '');
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);

  const canViewMedicationProfile =
    selectedTenancy?.userPermissions?.[
      SystemPermission.VIEW_MEDICATION_PROFILE
    ] || false;

  const canViewMedicationCatalog =
    selectedTenancy?.userPermissions?.[
      SystemPermission.VIEW_MEDICINE_CATALOG
    ] || false;

  return (
    <>
      <div className="settings-page">
        <div className="settings-page-title">{titleMap[locationKey]}</div>
        <div className="preference-container">
          {locationKey ===
          SettingsLeftNavbarMedicationSubTabs.MEDICATION_PROFILE_SETTINGS_ORDER ? (
            canViewMedicationCatalog ? (
              <MedicationOrderSets />
            ) : (
              <>Not able to view medication catalogue</>
            )
          ) : canViewMedicationProfile ? (
            <MedicationMedCatalogueProvider>
              <MedicationMedCatalogue />
            </MedicationMedCatalogueProvider>
          ) : (
            <>Not able to view medication order sets</>
          )}
        </div>
      </div>
    </>
  );
};
